export default {"src":"/_next/static/media/bullet_pink.154336a5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};